<template>
  <v-card flat class="product-list-item pointer" @click="jump">
    <v-layout wrap>
      <v-flex class="item-img-wrap mr-4" shrink>
        <img :src="product.productDetailBo.productImage">
        <div class="category-tag" v-if="product.tag">{{product.tag}}</div>
        <!-- <div class="category-tag">企业团体保障</div> -->
      </v-flex>
      <v-flex class="item-content" style="width:100%">
        <v-layout column justify-space-between fill-height>
          <v-layout justify-space-between shrink wrap >
            <v-flex xs12 md8>
              <h2>{{product.name}}</h2>
            </v-flex>
            <v-flex xs12 md4 class="text-md-right text-xs-left text2">{{product.productDetailBo.insurerName}}</v-flex>
          </v-layout>
          <v-layout class="features" wrap>
            <!-- 移动端显示 -->
            <table v-if="breakpoint.xs">
              <tr v-for="item in product.productDetailBo.features" :key="item">
                <td class="features-item text2">
                  <span>{{item}}</span>
                </td>
              </tr>
            </table>
            <!-- PC显示 -->
            <table v-else>
              <template v-for="n in product.productDetailBo.features.length">
                <tr v-if="n % 2 === 1" :key="n">
                  <td class="features-item text2">
                    <span>{{product.productDetailBo.features[n-1]}}</span>
                  </td>
                  <td class="features-item text2">
                    <span v-if="n < product.productDetailBo.features.length">{{product.productDetailBo.features[n]}}</span>
                  </td>
                </tr>
              </template>
            </table>
          </v-layout>

          <v-layout class="conditions-wrap" :class="{'mt-3':breakpoint.xs}" align-end wrap>
            <v-flex xs12 md8 class="conditions">
              <v-layout column justify-end>
                <v-flex v-for="item in product.productDetailBo.conditions" :key="item.title">
                  <c-icon :name="item.icon"></c-icon>
                  <span>{{ item.title }}： {{item.content}}</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md3 :class="{'mt-3':breakpoint.xs}">
              <div class="primary-text text-xs-right" v-html="product.price"></div>
            </v-flex>
          </v-layout>

        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="product-info-button-container" style="">
        <v-btn class="product-info-button" color="primary"
               style="">查看详情
        </v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    product:{
      type: Object,
      default: {}
    }
  },
  data() {
    return {
    };
  },
  computed: {
    // product() {
    //   return this.$store.getters.getProduct(this.code);
    // },
    tag() {
      let category = this.$store.getters.getCategoryById(this.product.dictId);
      return category.value;
    },
  },
  methods: {
    jump() {
      if (this.product.hasOwnProperty("toUrl") &&this.product.toUrl !== ""){
        return location.href = this.product.toUrl;
      }
      if (this.product.hasOwnProperty("pathUrl") && this.product.pathUrl !== ""){
        return this.$router.push(`${this.product.pathUrl}/${this.product.id}`);
      }
      return this.$router.push(`/product/new/detail/${this.product.id}`);
    },
  }
};
</script>

<style lang="scss" scoped>
@mixin sm-media {
  @media only screen and (max-width: map-get($breakpoints, sm)) {
    @content;
  }
}
.product-list-item {
  h2 {
    font-weight: 400;
  }
  padding: 30px;
  margin-bottom: 20px;
  .item-img-wrap {
    width:300px;
    overflow: hidden;
    text-align: center;
    position: relative;
    height: 220px;
    img{
      width: 100%;
      height: 100%;
    }
    .category-tag {
      position: absolute;
      top: 0;
      left: 0;
      padding: 7px 13px;
      border-bottom-right-radius: 19px;
      background-color: #292c31;
      opacity: 0.7;
      color: rgba(255, 255, 255, 0.7);
    }
  }
  .item-content {
    @include sm-media {
      margin-top: 1em;
    }
    max-width: 65%;
  }

  .features {
    margin-top: 20px;
    font-size: 15px;
    &-item {
      padding-right: 25px;
      span:before {
        content: "•";
        color: $primary-color;
        width: 5px;
        height: 5px;
        margin-right: 5px;
      }
    }
  }
}
</style>

<style lang="scss">
.product-list-item {
  .conditions-wrap {
    .primary-text {
      strong {
        font-size: 28px;
        font-weight: 400;
      }
    }
  }
}
  .product-info-button-container{
    position: relative;
    text-align: right;
    margin-right: 3%;
    .product-info-button{
      position: absolute;
      right: 0;
      width: 180px;
      height: 40px;
      bottom: 0;
    }
  }
  @media screen and (max-width: 960px){
    .product-info-button-container{
      height: 40px;
      .product-info-button{
        bottom: -10px;
      }
    }

  }
</style>


